import React from 'react';
import { useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from '@material-ui/core';




/*** REQUIRED FOR REDUX-FORM CHECKBOXES TO WORK -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS */
// import { ThemeProvider } from '@material-ui/styles';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
/*** REQUIRED FOR REDUX-FORM CHECKBOXES TO WORK -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS */




import theme from 'theme';
/*** date picker on forms */
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'assets/scss/index.scss';

import Routes from 'Routes';

/*** PASS THE CURRENT USER TO THE REST OF THE APP WHEN NEEDED - used by class components */
import { CONTEXT_USER_FOR_CLASS_COMPONENTSProvider } from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'

/*** PASS THE CURRENT USER TO THE REST OF THE APP WHEN NEEDED - used by hook function components */
export const CONTEXT_USER = React.createContext();

export const browserHistory = createBrowserHistory();

function App() {
  /*** this is the old container --- start */
  const auth = useSelector(state => state.auth);
  /*** this is the old componentDidMount - aka onLoad - you can have multiple useEffects --- end */
  return (
    /*** CONTEXT_USER.Provider passes the signed in users details to all components to have access -- react hooks */
    /*** CONTEXT_USER_FOR_CLASS_COMPONENTSProvider passes the signed in users details to all components to have access -- react components */
    /*** MuiThemeProvider & ThemeProvider theme providers this may pose an issue look at the material-ui get started guide to fix this */
    <CONTEXT_USER.Provider value={auth.user}>
      <CONTEXT_USER_FOR_CLASS_COMPONENTSProvider value={auth.user}>


      {/* /***  -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS    */}
      {/* /*** 2 theme providers this may pose an issue look at the material-ui get started guide to fix this   */}
      <MuiThemeProvider>
      {/* /***  -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS    */}



        <ThemeProvider theme={theme}>
          {/* <Router history={browserHistory} basename={'/psi'}> */}
          <Router history={browserHistory} >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Routes />
            </MuiPickersUtilsProvider>
          </Router>
        </ThemeProvider>



      {/* /***  -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS    */}
      </MuiThemeProvider>
      {/* /***  -- WHEN YOU CONVERT TO FINAL FORM REMOVE THIS    */}



      </CONTEXT_USER_FOR_CLASS_COMPONENTSProvider>
    </CONTEXT_USER.Provider>
  );
}
export default App;

/*
HOOKS
APP.js
    <CONTEXT_USER.Provider value={auth.user}>

Using in a component
    how to use this to get the data while in a component

    import React, { useContext } from 'react';

    // / *** signed in user * /
    import {CONTEXT_USER} from 'App';
    
    // / *** SIGNED IN USER DETAILS * /
    const CONST_CONTEXT_USER = useContext(CONTEXT_USER);
    
    {CONST_CONTEXT_USER.role}





CLASS COMPONENTS
https://www.taniarascia.com/using-context-api-in-react/

APP.js
    // / *** signed in user * /
      import { CONTEXT_USER_FOR_CLASS_COMPONENTSProvider } from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'
      <CONTEXT_USER_FOR_CLASS_COMPONENTSProvider value={auth.user}>

Using in a component
    // / *** signed in user * /
  import  CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'

  class Referrals extends Component {
    // / *** signed in user * /
    static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS
    componentDidMount () {
    // / *** signed in user * /
      const c_USER = this.context
      console.log('949494 - GGuser = ' , c_USER);
      this.props.getReferrals(c_USER.id)
      this.props.getProgramsAssignedToLoginList(c_USER.id)
    }
  }

*/
